import _ from 'lodash'
import Promise from 'promise'
import axios from 'axios'
import store from '../store'
import router from '../router'
import { Message } from 'element-ui/src'
import Config from '../config'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = false
let Api = {}
let methodsWithParams = ['get', 'head', 'delete']
// 返回 {promise, cancelHandler(用于取消请求)}
Api.http = function (url, method, data, params, ignoreCache, responseType, contentType) {
  if (!data) {
    data = {}
  } else {
    data = _.cloneDeep(data)
  }
  let opts = {}
  let isQueryMethod = false
  if (_.indexOf(methodsWithParams, method) > -1) {
    isQueryMethod = true
    // 如果传入了body值，则 data 表示 body 值，params 表示 URL参数
    if (params) {
      opts.params = params
      opts.data = data
    } else {
      opts.params = data || ignoreCache && (opts.params.t = new Date().getTime())
    }
  } else if (params) {
    opts.params = params
  }
  opts.headers = {}
  if (contentType) {
    opts.headers['Content-Type'] = contentType
  }
  if (store.state.auth) {
    opts.headers.Authorization = 'Bearer ' + store.state.auth.token
  }
  let cancelHandler
  opts.cancelToken = new axios.CancelToken(cancel => {
    cancelHandler = cancel
  })
  if (responseType) {
    opts.responseType = responseType
  }
  return {
    promise: (isQueryMethod ? axios[method](url, opts) : axios[method](url, data, opts)).then(resp => {
      if (responseType) {
        return resp
      }
      if (resp.data.total !== undefined || resp.data.gid !== undefined) {
        return resp.data
      } else {
        let statusCode = resp.data.code
        if (statusCode === 0) {
          return resp.data.data
        } else {
          Message.error(resp.data.Des || resp.data.des || '访问异常')
        }
      }
      return Promise.reject(resp)
    }, resp => {
      let message
      let toLogin
      if (resp.message === 'Network Error') message = '网络错误，请检查您的网络连接！'
      else {
        switch (resp.response.status) {
          case 401:
            message = '身份验证过期,请重新登录'
            Message.error(message)
            toLogin = true
            setTimeout(() => {
              store.commit("logout");
              router.push({ path: '/login', query: { backUrl: router.currentRoute.fullPath } })
            }, 100)
            break
          default:
            message = resp.response.data && (resp.response.data.des || resp.response.data.Des) || '访问异常'
        }
      }
      if (message.indexOf('LoginInfo') > -1) {
        toLogin = true
        message = '登录信息已过期，请重新登录'
      }
      Message.error(message)
      if (toLogin && router.currentRoute.path !== '/login') {
        store.commit('logout')
        router.push({ path: '/login', query: { backUrl: router.currentRoute.fullPath } })
      }
      return Promise.reject(resp)
    }),
    cancelHandler: () => {
      cancelHandler && cancelHandler()
    }
  }
}

Api.login = function (loginName, password) {
  return axios.post(Config.API_URL + 'login/bypwd', {}, {
    headers: {
      Authorization: 'Basic ' + btoa(loginName + ':' + password)
    }
  }).then(resp => {
    let rst = resp.data
    if (rst && rst.code === 0) {
      if (rst.data.userRole === 16) {
        store.commit('setAuth', rst.data)
        return rst
      } else {
        return new Promise.reject(resp)
      }

    } else {
      return new Promise.reject(resp)
    }
  }, resp => {
    Message.error('登录失败')
    return new Promise.reject(resp)
  })
}

export default Api